import { Link } from 'expo-router';
import { LabelRegular } from 'smoothie';

export const LegalLink = ({
    href,
    color,
    children,
}: {
    href: string;
    color: string;
    children: string;
}) => {
    return (
        <Link target="_blank" href={href} rel="noopener noreferrer">
            <LabelRegular color={color} textDecorationLine="underline">
                {children}
            </LabelRegular>
        </Link>
    );
};
